import React from 'react';
import {inject, observer } from 'mobx-react';
import defaultLogoUrl from "styles/img/no-cert-sign.png";
import HttpClient from "services/HttpClient";
const UPDATE_USER = '/api/v1/users/update_profile';
const SHOW_TEMPLATE = '/api/v1/pdfs/show_template';


@inject('user')
@observer
export default class MyOnlineWorkshopsCert extends React.Component {

  state = {
    user: {},
    generateCerts: false
  }

  componentDidMount() {
    const user = this.props.user.getUser();
    this.setState({
      user: user,
      generateCerts: user.is_cert_generated
    })
  }

  toggleCerts = e => {
    this.setState({
      ...this.state,
      generateCerts: !this.state.generateCerts
    }, () => {
      new HttpClient()
        .put(UPDATE_USER, { is_cert_generated: this.state.generateCerts })
        .then( response => this.props.user.setUser(response.body.data.user));
    })
  }

  loadAttachment = (e, field) => {
    const file = e.currentTarget.files[0];
    // const url = `/api/v1/workshops/${this.state.workshop.id}`;
    let formData = new FormData();

    formData.append(`user[${field}]`, file);

    new HttpClient().multipart(UPDATE_USER, formData, "PUT").then(response => {
      const user = response.body.data.user;
      this.props.user.setUser(response.body.data.user)
      this.setState({ user: user });
    });
  };

  showTemplate = () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    fetch(SHOW_TEMPLATE, init)
    .then(resp => {
      if(resp.status=='200'){
      resp.blob()
      .then( file => {
      let objUrl = window.URL.createObjectURL(file)
        window.open(objUrl)
    })
    }
    else {
      alert("Something went wrong. Please check your connection or try again later")
    }
  })
  }

  render() {
    const { user } = this.state;

    const LogoSign = (
      <div>
        <div className="wrapper-logo-signature">
          <div className="logo-block">
            <div className="img-container">
              <input
                type="file"
                onChange={e => this.loadAttachment(e, "logo")}
              />
              <img src={user.logo_url || defaultLogoUrl} alt="no-img" />
            </div>
            <span>LOGO</span>
          </div>
          <div className="sign-block">
            <div className="img-container">
              <input
                type="file"
                onChange={e => this.loadAttachment(e, "signature")}
              />
              <img
                src={user.signature_url || defaultLogoUrl}
                alt="no-img"
              />
            </div>
            <span>E-SIGNATURE</span>
          </div>
        </div>
        <div className="cert-preview-container">
          <button className='btn bordered card-btn cert-preview-btn' onClick={()=> this.showTemplate()}>
            PREVIEW CPD CERT TEMPLATE
          </button>
        </div>
      </div>
    )

    return (
      <div className="cpd-toggle-wrapper">
        <h2 className="workshop-list-title workshop-list-top-holder hide-xs hide-s">CPD CERT TEMPLATE</h2>
        <div className="switcher-wrapper">
            <p className="label custom-style-padding cpd-cert-template-title">
              Customise the CPD cert that Trainees receive when they complete your online workshop
            </p>
            { false &&
              <div className="switcher">
                <input type="checkbox"
                  id="generateCerts"
                  value={this.state.generateCerts}
                  onChange={this.toggleCerts}
                  checked={this.state.generateCerts} />
                <label htmlFor="generateCerts" />
              </div>
            }
        </div>
        { LogoSign }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/providers/MyOnlineWorkshopsCert.jsx